import React, { useEffect, useRef } from "react";
import { ModalUi } from "../../../ui/ModalUi";
import { ButtonUi } from "../../../ui/ButtonUi";
import { TipoButtonConstants } from "../../../../types/typesConstants";
import { Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { FormUi } from "../../../ui/FormUi";
import { RutaUploadForm } from "./RutaUploadForm";
import { rutaJsonStartUpload } from "../../../../actions/usuario";
const initialValues = {
  modulo: null,
  file: [],
};
const useResetFormOnCloseModal = ({ form, open }) => {
  const prevOpenRef = useRef();
  useEffect(() => {
    prevOpenRef.current = open;
  }, [open]);
  const prevOpen = prevOpenRef.current;

  useEffect(() => {
    if (!open && prevOpen) {
      form.resetFields();
    }
  }, [form, prevOpen, open]);
};
export const RutaUploadModal = ({ open, handleCloseModal }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { activeModulo } = useSelector((state) => state.usuario);
  useResetFormOnCloseModal({ form, open });
  const handleSubmit = (values) => {
    values = {
      file: values?.file?.[0]?.originFileObj,
      modulo: activeModulo?.id,
    };
    dispatch(rutaJsonStartUpload(values));
  };
  return (
    <ModalUi
      title="Importa rutas en modulo"
      open={open}
      onCancel={handleCloseModal}
      footer={[
        <ButtonUi
          key="back"
          typeUi={TipoButtonConstants.Cancelar}
          onClick={handleCloseModal}
        />,
        <ButtonUi
          key="submit"
          typeUi={TipoButtonConstants.Guardar}
          htmlType="submit"
          form="FormImportarRuta"
        />,
      ]}
      forceRender
    >
      <FormUi
        name="FormImportarRuta"
        form={form}
        layout="horizontal"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        autoComplete="off"
        initialValues={initialValues}
        handleSubmit={handleSubmit}
      >
        <RutaUploadForm />
      </FormUi>
    </ModalUi>
  );
};
